import { render, staticRenderFns } from "./BankSearch.vue?vue&type=template&id=88464df8&scoped=true"
import script from "./BankSearch.vue?vue&type=script&lang=js"
export * from "./BankSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88464df8",
  null
  
)

export default component.exports